jQuery(document).ready(function ($) {
	$( ".modalVideo" ).click(
		function(event) {
			event.preventDefault()
		}
	)
	$( ".modalVideo.modalVideo--youtube" ).modalVideo(
		{channel:'youtube',
			youtube: {
				autoplay: 1,
        rel: 0,
			}
		}
	)

  $( ".modalVideo.modalVideo--vimeo" ).modalVideo(
    {channel:'vimeo',
      vimeo: {
        autoplay: true,
      }
    }
  )
})
